<div [innerHTML]="processedText"></div>

